import React from 'react';
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const spinner = keyframes`
    from {transform: rotateZ(0deg);}
    to {transform: rotateZ(360deg);}
`;
const borderRatio = 9;
const LoadingSpinner = styled.div`
	height: ${({$height}) => $height}px;
	width: ${({$width}) => $width}px;
	border-top: ${({$width}) => $width / borderRatio}px solid ${({$fill}) => $fill || 'black'};
	border-left: ${({$width}) => $width / borderRatio}px solid ${({$fill}) => $fill || 'black'};
	border-right: ${({$width}) => $width / borderRatio}px solid ${({$fill}) => $fill || 'black'};
	border-bottom: ${({$width}) => $width / borderRatio}px solid transparent;
	border-radius: 50%;
	animation: ${spinner} 2s infinite;
`;

const Spinner = (props) => (
	<LoadingSpinner 
		$width={32} 
		$height={32} 
		{...props}
	/>
); 

export default Spinner;